export default __webpack_public_path__ + "static/media/one_stars.60fbbfb9.svg";